import { userInstance } from '../utils/axiosConfig';

const AccountDeletionService = {
    /**
     * Créer une demande de suppression de compte
     * @param {Object} dto - AccountDeletionRequestDTO
     * @param {string} language - Langue acceptée
     * @returns {Promise<Object>} AccountDeletionResponseDTO
     */
    createRequest: async (dto, language) => {
        try {
            const response = await userInstance.post('/account-deletion/request', dto, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': language || 'fr'
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error in createRequest:', error.message || error);
            throw error;
        }
    },

    /**
     * Valider le token reçu par email
     * @param {string} token - Token à 6 chiffres
     * @param {string} language - Langue acceptée
     * @returns {Promise<Object>} AccountDeletionResponseDTO
     */
    validateToken: async (token, language) => {
        try {
            const response = await userInstance.post('/account-deletion/validate-token', null, {
                params: {
                    token: token
                },
                headers: {
                    'Accept-Language': language || 'fr'
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error in validateToken:', error.message || error);
            throw error;
        }
    },

    /**
     * Récupérer toutes les demandes de suppression (sauf PENDING_TOKEN)
     * @param {string} language - Langue acceptée
     * @returns {Promise<Array>} Liste des AccountDeletionResponseDTO
     */
    findAll: async (language) => {
        try {
            const response = await userInstance.get('/account-deletion/all', {
                headers: {
                    'Accept-Language': language || 'fr'
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error in findAll:', error.message || error);
            throw error;
        }
    },

    /**
     * Récupérer uniquement les demandes avec token validé
     * @param {string} language - Langue acceptée
     * @returns {Promise<Array>} Liste des AccountDeletionResponseDTO avec status TOKEN_VALIDATED
     */
    findAllValidated: async (language) => {
        try {
            const response = await userInstance.get('/account-deletion/validated', {
                headers: {
                    'Accept-Language': language || 'fr'
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error in findAllValidated:', error.message || error);
            throw error;
        }
    },

    /**
     * Approuver une demande de suppression (supprime le compte)
     * @param {number} id - ID de la demande
     * @param {string} language - Langue acceptée
     * @returns {Promise<Object>} AccountDeletionResponseDTO
     */
    approve: async (id, language) => {
        try {
            const response = await userInstance.post(`/account-deletion/approve/${id}`, null, {
                headers: {
                    'Accept-Language': language || 'fr'
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error in approve:', error.message || error);
            throw error;
        }
    },

    /**
     * Rejeter une demande de suppression
     * @param {number} id - ID de la demande
     * @param {string} reason - Motif du rejet
     * @param {string} language - Langue acceptée
     * @returns {Promise<Object>} AccountDeletionResponseDTO
     */
    reject: async (id, reason, language) => {
        try {
            const response = await userInstance.post(`/account-deletion/reject/${id}`, null, {
                params: {
                    reason: reason
                },
                headers: {
                    'Accept-Language': language || 'fr'
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error in reject:', error.message || error);
            throw error;
        }
    },

    /**
     * Renvoyer un nouveau token par email
     * @param {string} email - Email de l'utilisateur
     * @param {string} language - Langue acceptée
     * @returns {Promise<void>}
     */
    resendToken: async (email, language) => {
        try {
            const response = await userInstance.post('/account-deletion/resend-token', null, {
                params: {
                    email: email
                },
                headers: {
                    'Accept-Language': language || 'fr'
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error in resendToken:', error.message || error);
            throw error;
        }
    }
};

export default AccountDeletionService;